function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { Constants } from '../utils/constants';
import { getWindow } from 'services/window';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
export class DynamicCampaign extends SpzaComponent {
    componentDidMount() {
        // add a function to the window object to be able to call a component method from the html
        window.ctaCallback = (ctaEntity)=>this.showDialog(ctaEntity);
        this.generateLoadingPageTelemetry();
    }
    generateLoadingPageTelemetry() {
        if (this.props.dynamicCampaign) {
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.PageLoad,
                actionModifier: Constants.Telemetry.ActionModifier.End
            };
            this.instrument.probe('logTelemetryInfo', payload);
            logger.info('', {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        }
    }
    generateCtaClickTelemetry() {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.AppDynamicCampaignCTAButton
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info('', {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    showDialog(ctaEntity) {
        this.generateCtaClickTelemetry();
        const entity = {
            entityId: ctaEntity.appId
        };
        this.context.ctaCallback({
            entity,
            entityType: ctaEntity.entityType,
            ctaType: ctaEntity.ctaType,
            actionModifier: Constants.Telemetry.ActionModifier.AppDynamicCampaignCTAButton
        });
    }
    createHtmlMarkup() {
        const dynamicCampaign = this.props.dynamicCampaign;
        return {
            __html: dynamicCampaign.html
        };
    }
    renderDefaultPage() {
        return /*#__PURE__*/ _jsx("div", {
            className: "campaignDefaultPage Header c-heading-2",
            children: "Campaign not found !"
        });
    }
    renderImpl() {
        // eslint-disable-next-line react/no-danger
        return this.props.dynamicCampaign ? /*#__PURE__*/ _jsx("div", {
            dangerouslySetInnerHTML: this.createHtmlMarkup()
        }) : this.renderDefaultPage();
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "instrument", void 0);
        this.instrument = SpzaInstrumentService.getProvider();
        this.showDialog = this.showDialog.bind(this);
    }
}
DynamicCampaign.contextTypes = {
    loc: PropTypes.func,
    locDateString: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func,
    contactCallback: PropTypes.func,
    renderErrorModal: PropTypes.func,
    openTileCallback: PropTypes.func
};
